import React from 'react';
import ReactDOM from 'react-dom';
import ReactTooltip from 'react-tooltip';

class Tooltip extends React.Component<any> {
  render() {
    return ReactDOM.createPortal(
      <ReactTooltip {...this.props} />,
      document.body
    );
  }
}

export default Tooltip;
